import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Checkbox,
  Modal,
  Box,
  Grid,
} from "@mui/material";
import Sidebar from "./Sidebar"; // Import your Sidebar component
import axios from "axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";

const PortfolioManagement = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [propertyDetail, setPropertyDetail] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [totalItems, setTotalItems] = useState(0); // State for total properties
  const usersPerPage = 8; // Number of users to display per page
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchPropertyDetails();
  }, [currentPage]);

  const fetchPropertyDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `https://yelospace.com/api/space-feeds?page=${
          currentPage - 1
        }&size=${usersPerPage}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setPropertyDetail(response?.data?.response);
      setTotalItems(response?.data?.response?.totalItems || 0);
      // Update total properties and ensure it's valid
    } catch (error) {
      console.error("Error fetching property details:", error);
    }
  };

  const fetchPropertyList = async (spaceFeedId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `https://yelospace.com/api/space-feed-details/${spaceFeedId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setPropertyList(response?.data?.response);
      setSelectedProperty(spaceFeedId);
    } catch (error) {
      console.error("Error fetching property details:", error);
    }
  };

  const deleteProperty = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      await axios.post(
        `https://yelospace.com/api/space-feed-delete/${id}`,
        null,
        { headers }
      );
      fetchPropertyDetails();
      setSelectedProperty(null);
      //console.log"Property Deleted Successfully");
    } catch (error) {
      console.error("Error deleting property:", error);
    }
  };

  const handleOpenModal = (spaceFeedId) => {
    setIsModalOpen(true);
    fetchPropertyList(spaceFeedId);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleCheckboxChange = (spaceFeedId) => {
    if (selectedProperty === spaceFeedId) {
      setSelectedProperty(null); // Uncheck if the same checkbox is clicked again
    } else {
      setSelectedProperty(spaceFeedId); // Check the new checkbox
    }
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Container style={{ display: "flex", marginTop: "20px" }}>
      <Sidebar />

      <div style={{ flex: "1", marginLeft: "20vw" }}>
        <Typography
          variant="h6"
          style={{
            color: "#F5C000",
            fontWeight: "bold",
            marginBottom: "12px",
            marginTop: "24px",
          }}
        >
          Portfolio Management
        </Typography>
        <Paper
          elevation={0}
          style={{ width: "100%", border: "1px solid #fee9c5" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px",
              borderBottom: "1px solid #F5C000",
            }}
          >
            <Typography variant="body1" component="p">
              Properties ({totalItems}) {/* Updated total properties */}
            </Typography>
            <div style={{ display: "flex" }}>
              <Button
                onClick={() => deleteProperty(selectedProperty)}
                variant="contained"
                style={{
                  color: "#000",
                  borderRadius: "12px",
                  backgroundColor: "#F5C000",
                  boxShadow: "none",
                  border: "1px solid #F5C000",
                }}
              >
                Delete
              </Button>
            </div>
          </div>

          <TableContainer>
            <Table style={{ border: "1.5px solid #fee9c5" }}>
              <TableHead>
                <TableRow style={{ borderBottom: "1.5px solid #fee9c5" }}>
                  <TableCell></TableCell>
                  <TableCell>
                    <b>Property Type</b>
                  </TableCell>
                  <TableCell>
                    <b>Property Sub-Type</b>
                  </TableCell>
                  <TableCell>
                    <b>Property Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Address</b>
                  </TableCell>
                  <TableCell>
                    <b>Zip Code</b>
                  </TableCell>
                  <TableCell>
                    <b>State</b>
                  </TableCell>
                  <TableCell>
                    <b>Actions</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {propertyDetail?.spaceFeeds?.map((row) => (
                  <TableRow
                    key={row.id}
                    style={{ borderBottom: "1.5px solid #fee9c5" }}
                  >
                    <TableCell>
                      <Checkbox
                       checked={selectedProperty === row?.spaceFeedId}
                        onChange={() => handleCheckboxChange(row?.spaceFeedId)}
                        style={{ color: "#F5C000" }}
                      />{" "}
                      {/* Row Checkbox */}
                    </TableCell>
                    <TableCell>{row?.spaceFeedDetails?.businessType}</TableCell>
                    <TableCell>
                      {row?.spaceFeedDetails?.subBusinessType}
                    </TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.address1}</TableCell>
                    <TableCell>{row.pin}</TableCell>
                    <TableCell>{row.state}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleOpenModal(row?.spaceFeedId)}>
                        <VisibilityIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Pagination */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          {[...Array(Math.ceil(totalItems / usersPerPage))].map((_, index) => (
            <Button
              key={index}
              variant="contained"
              style={{
                borderRadius: "20px",
                marginRight: "5px",
                backgroundColor:
                  currentPage === index + 1 ? "#5F5F61" : "white",
                color: currentPage === index + 1 ? "white" : "#5F5F61",
              }}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </Button>
          ))}
        </div>
      </div>

      {/* Modal */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
            height: 600,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            overflowY: "scroll", // Add vertical scroll
          }}
        >
          <Grid container justifyContent="flex-end">
            <Button onClick={handleCloseModal}>
              <CloseIcon />
            </Button>
          </Grid>
          <Typography variant="h5" component="div" gutterBottom>
            Property Details
          </Typography>

          <div key={propertyList?.id}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ flex: 1 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Property Type: {propertyList?.categoryName}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Price/SQFT: {propertyList?.spaceFeedDetails?.price}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Total SQFT : {propertyList?.spaceFeedDetails?.totalSpace}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Remaining Lease Term:{" "}
                  {propertyList?.spaceFeedDetails?.remainingLeaseTerm}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Business Type: {propertyList?.spaceFeedDetails?.businessType}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Layout : {propertyList?.spaceFeedDetails?.layout}
                </Typography>
              </div>
              <div style={{ flex: 1 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Subtype: {propertyList?.subCategoryName}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Total Rent Fee + Other Costs :{" "}
                  {propertyList?.spaceFeedDetails?.rent}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Available SQFT :{" "}
                  {propertyList?.spaceFeedDetails?.availableSpace}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Minimum Sub Lease Term :{" "}
                  {propertyList?.spaceFeedDetails?.minSubLeaseTerm}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Sub Lease Business Type :{" "}
                  {propertyList?.spaceFeedDetails?.subBusinessType}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Parking : {propertyList?.spaceFeedDetails?.parking}
                </Typography>
              </div>
            </div>
            <Typography variant="h6" gutterBottom>
              Property Description
            </Typography>
            <Typography variant="body1" gutterBottom>
              {propertyList?.spaceFeedDetails?.description}
            </Typography>
            <Typography variant="h6" gutterBottom>
              Property Image
            </Typography>
            {propertyList?.spaceFeedMedia?.map((item) => {
              let itemurl = item.url;
              
              return (
                <Typography variant="body1" gutterBottom>
                  <a href={item?.url} target="_blank">{item.fileName} </a>
                </Typography>
              );
            })}
          </div>
        </Box>
      </Modal>
    </Container>
  );
};

export default PortfolioManagement;
